import { useMemo } from 'react';
import Cookies from 'js-cookie';

import { Text } from '@restworld/ui-ds-base';
import { MenuSelector, MenuSelectorItemProps } from '../menu-selector';

type LocaleSelectorProps = {
  onChange: (locale: string) => void;
  value?: string;
  background?: string;
};

export const LocaleSelector = ({ onChange, value = 'it', background = 'white' }: LocaleSelectorProps) => {
  const localeList = useMemo(
    () => [
      {
        countryCode: 'IT',
        displayCode: 'IT',
        language: 'Italiano',
        value: 'it',
      },
      {
        countryCode: 'GB',
        displayCode: 'EN',
        language: 'English',
        value: 'en',
      },
    ],
    []
  );

  const getFlag = (countryCode: string) => {
    return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`;
  };
  const localeOptions: MenuSelectorItemProps[] = useMemo(
    () =>
      localeList.map((locale) => ({
        label: (
          <div className="flex flex-row justify-start items-center gap-2">
            <img src={getFlag(locale.countryCode)} width={20} height={14} alt={locale.countryCode} />
            <span>{locale.language}</span>
          </div>
        ),
        value: locale.value,
      })),
    [localeList]
  );

  const defaultLocaleLabel = useMemo(() => {
    const selectedLocale = localeList.find((locale) => locale.value === value);
    if (!selectedLocale) return null;
    return (
      <div className="flex items-center gap-2">
        <img src={getFlag(selectedLocale.countryCode)} width={20} height={14} alt={selectedLocale.countryCode} />
        <Text as="span" size={3} weight="normal" color="black">
          {`${selectedLocale.language} (${selectedLocale.displayCode})`}
        </Text>
      </div>
    );
  }, [localeList, value]);

  return (
    <MenuSelector
      options={localeOptions}
      onSelect={(value) => {
        Cookies.set('NEXT_LOCALE', value as string, { expires: 365 * 24 * 60 * 60 });
        onChange(value as string);
      }}
      selectedLabel={defaultLocaleLabel}
      menuDialogStyles={['px-1 pr-1 w-[174px]']}
      menuButtonStyles={['gap-1 px-4 py-3 text-base border border-gray-200 rounded-lg']}
      menuItemStyles={['px-1 lg:text-base text-base font-normal']}
      background={background}
    />
  );
};

export default LocaleSelector;
